import { FLAG_PAGE_BLOCKS_PADDING } from '@modules/HappinessModule/pages/FlagPage/constants/constants';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  mainContainer: {
    padding: FLAG_PAGE_BLOCKS_PADDING,
  },
  anotherOfferInvolvedBlockHrViewCollapsed: {
    padding: '50px 65px 50px 59px',
  },
  anotherOfferInvolvedBlockHrViewExpaneded: {
    padding: '50px 65px 80px 59px',
  },
});
